<template>
  <div class="m-ranking">
    <div v-if="superInfo.activityCategory === 2" class="ranking-hd">
      <div class="title"></div>
      <p class="rh-tips">
        公示截止时中奖份额排名前{{ superInfo.rankQuota }}获奖
      </p>
    </div>
    <div class="ranking-tab">
      <span class="rank-col">排名</span>
      <span class="user-col">用户信息</span>
      <span class="prize-col">中奖份额</span>
    </div>
    <div class="ranking-list">
      <div v-if="rankingList && rankingList.length">
        <div
          v-for="(item, index) in rankingList"
          :key="index"
          class="ranking-item"
        >
          <div class="rank-col">
            <span v-if="index === 0" class="rank-num rank-1">1</span>
            <span v-else-if="index === 1" class="rank-num rank-2">2</span>
            <span v-else-if="index === 2" class="rank-num rank-3">3</span>
            <span v-else class="rank-num rank-other">{{ item.rankNum }}</span>
          </div>
          <div class="user-col">
            <div class="avatar-wrap">
              <img
                v-if="item.avatar"
                :src="item.avatar"
                class="avatar"
                alt=""
              />
              <div v-else class="avatar-placeholder"></div>
              <div v-if="item.isHit == 1" class="award-tag">获得奖励</div>
            </div>
            <span class="username text-line-1">{{
              item.nickname || "用户"
            }}</span>
          </div>
          <div class="prize-col">
            <span
              :class="[
                'prize-value',
                index === 0
                  ? 'rank-1'
                  : index === 1
                  ? 'rank-2'
                  : index === 2
                  ? 'rank-3'
                  : '',
              ]"
            >
              {{ item.ticketCount || 0 }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">
        <div class="empty-text">暂无数据</div>
      </div>
    </div>

    <div v-if="rankStats == 'end'" class="my-ranking">
      <span class="label">我的排名</span>
      <span class="my-rank">{{ displayRankNum }}</span>
    </div>

    <div v-else class="my-ranking">
      <span class="label">我的中奖份额</span>
      <span class="my-prize">{{
        superInfo.userInfo.myParticipatedTicketCount || 0
      }}</span>
      <span class="divider">｜</span>
      <span class="label">当前排名</span>
      <span class="my-rank">{{ displayRankNum }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getQuery } from "@utils/url";
// import service from "@utils/service.js";

export default {
  name: "MRanking",
  data() {
    return {
      superId: getQuery("superId") || "",
    };
  },
  components: {},
  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
    couponType: {
      type: [String, Number],
      default: () => "",
    },

    rankStats: {
      type: String,
      default: () => "",
    },
    rankingList: {
      type: Array,
      default: () => [],
    },
    rankNumStr: {
      type: [String, Number],
      default: () => 0,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    displayRankNum() {
      const num = Number(this.rankNumStr);
      return num < 0 ? 0 : this.rankNumStr;
    },
  },
  watch: {
    rankingList: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less">
.m-ranking {
  width: 290px;
  margin: 0 auto;
  box-sizing: border-box;
  .ranking-hd {
    margin-bottom: 15px;
    .title {
      width: 130.5px;
      height: 25px;
      margin: 0 auto 5px;
      background-image: url("../assets/image/rank/icon-tit01.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center top;
    }
    .rh-tips {
      font-weight: 400;
      font-size: 13px;
      color: rgba(0, 26, 51, 0.5);
      text-align: center;
    }
  }

  .ranking-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin-bottom: 5px;
    padding: 0 15px 0 0;
    font-size: 13px;
    color: #969799;
    font-weight: 500;
    background: rgba(246, 247, 247, 0.8);
    border-radius: 5px;

    .rank-col {
      width: 40px;

      text-align: center;
    }
    .user-col {
      flex: 1;
      text-align: left;
      padding-left: 8px;
    }
    .prize-col {
      width: 70px;
      text-align: right;
      font-weight: 600;
    }
  }

  .ranking-list {
    overflow-y: auto;
    max-height: 150px;
    margin-bottom: 15px;
    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px 0;
      .empty-text {
        font-size: 13px;
        color: rgba(0, 26, 51, 0.4);
      }
    }
    .ranking-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 55px;
      background: #f6f7f7;
      border-radius: 5px;
      margin-bottom: 5px;

      .rank-col {
        width: 40px;
        display: flex;
        justify-content: center;
        .rank-num {
          font-family: ArialNarrow;
          font-weight: bold;
          font-size: 18px;
          color: #323233;
          &.rank-1 {
            color: #ff8500;
          }
          &.rank-2 {
            color: #257aff;
          }
          &.rank-3 {
            color: #18e082;
          }
        }
      }

      .user-col {
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 8px;

        .avatar-wrap {
          position: relative;
          margin-right: 11px;

          .avatar {
            display: block;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            object-fit: cover;
          }

          .avatar-placeholder {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background: #f2f3f5;
          }

          .award-tag {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: -6px;
            left: 5px;
            width: 38px;
            height: 11px;
            font-size: 7px;
            color: #ffffff;
            background: #00223b;
            border-radius: 6px 0px 6px 0px;
            border: 1px solid #ffffff;
            white-space: nowrap;
          }
        }

        .username {
          font-weight: 400;
          font-size: 13px;
          color: rgba(0, 0, 0, 0.54);
        }
      }

      .prize-col {
        width: 70px;
        padding-right: 15px;
        text-align: right;

        .prize-value {
          font-weight: 500;
          font-size: 15px;
          color: #323233;
          &.rank-1 {
            color: #ff8500;
          }
          &.rank-2 {
            color: #257aff;
          }
          &.rank-3 {
            color: #18e082;
          }
        }
      }
    }
    .ranking-item:last-child {
      margin-bottom: 0;
    }
  }

  .my-ranking {
    display: flex;
    align-items: center;
    justify-content: center;
    .label {
      font-weight: 400;
      font-size: 13px;
      color: rgba(0, 26, 51, 0.6);
    }

    .my-prize {
      font-weight: bold;
      font-size: 14px;
      color: #001a33;
      margin-left: 4px;
    }

    .divider {
      color: #dcdee0;
      margin: 0 12px;
    }

    .my-rank {
      font-weight: bold;
      font-size: 14px;
      color: #001a33;
      margin-left: 4px;
    }
  }
}
</style>
